import { render, staticRenderFns } from "./MagazineListView.vue?vue&type=template&id=fb478360&"
import script from "./MagazineListView.vue?vue&type=script&lang=js&"
export * from "./MagazineListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports